import axiosInstance from '../axiosConfig';

export interface Project {
    id: number;
    title: string;
    image: string;
    image_url: string;
    description?: string;
    date?: string;
    author?: string;
    comments?: number;
    order: number;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export interface ProjectsResponse {
    success: boolean;
    data: Project[];
    message: string;
    count: number;
    meta?: {
        total: number;
        per_page: number;
        current_page: number;
        last_page: number;
    };
}

export interface ProjectResponse {
    success: boolean;
    data: Project;
    message: string;
}

export const projectService = {
    async initializeCsrf() {
        try {
            await axiosInstance.get('/sanctum/csrf-cookie');
            console.log('CSRF token initialized');
        } catch (error) {
            console.error('Failed to initialize CSRF token:', error);
        }
    },

    async getAll(params?: { page?: number; per_page?: number; search?: string }): Promise<ProjectsResponse> {
        try {
            const response = await axiosInstance.get('/api/admin/projects', { params });
            return response.data;
        } catch (error) {
            console.error('Error in getAll:', error);
            throw error;
        }
    },

    async getById(id: number): Promise<ProjectResponse> {
        try {
            const response = await axiosInstance.get(`/api/admin/projects/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in getById:', error);
            throw error;
        }
    },

    async create(formData: FormData): Promise<ProjectResponse> {
        try {
            const response = await axiosInstance.post('/api/admin/projects', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in create:', error);
            throw error;
        }
    },

    async update(id: number, formData: FormData): Promise<ProjectResponse> {
        try {
            formData.append('_method', 'PUT');
            const response = await axiosInstance.post(`/api/admin/projects/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in update:', error);
            throw error;
        }
    },

    async delete(id: number): Promise<{ success: boolean; message: string }> {
        try {
            const response = await axiosInstance.delete(`/api/admin/projects/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in delete:', error);
            throw error;
        }
    },

    async bulkDelete(ids: number[]): Promise<{ success: boolean; message: string; deleted_count?: number }> {
        try {
            const response = await axiosInstance.post('/api/admin/projects/bulk-delete', { ids });
            return response.data;
        } catch (error) {
            console.error('Error in bulkDelete:', error);
            throw error;
        }
    },

    async updateStatus(id: number, isActive: boolean): Promise<{ success: boolean; message: string; data: any }> {
        try {
            const response = await axiosInstance.patch(`/api/admin/projects/${id}/status`, {
                is_active: isActive
            });
            return response.data;
        } catch (error) {
            console.error('Error in updateStatus:', error);
            throw error;
        }
    },

    async reorder(orders: { id: number; order: number }[]): Promise<{ success: boolean; message: string }> {
        try {
            const response = await axiosInstance.post('/api/admin/projects/reorder', { orders });
            return response.data;
        } catch (error) {
            console.error('Error in reorder:', error);
            throw error;
        }
    }
};